export default __webpack_public_path__ + "static/media/phapoom_img7.b121fb32.webp";